<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.5833 15.9167H15.9167V19.5833H14.0833V15.9167H10.4167V14.0833H14.0833V10.4167H15.9167V14.0833H19.5833V15.9167ZM21.4167 6.75H8.58333C7.56583 6.75 6.75 7.56583 6.75 8.58333V21.4167C6.75 21.9029 6.94315 22.3692 7.28697 22.713C7.63079 23.0568 8.0971 23.25 8.58333 23.25H21.4167C21.9029 23.25 22.3692 23.0568 22.713 22.713C23.0568 22.3692 23.25 21.9029 23.25 21.4167V8.58333C23.25 7.56583 22.425 6.75 21.4167 6.75Z" fill="#109CF1"/>
  </svg>
</template>

<script>
  export default {
    name: "blueBG-PlusIcon"
  }
</script>

<style scoped>

</style>
